import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Container from "./Container";
import Head from "./Head";
import Header from "./Header";
import Menu from "./Menu";
import Title from "./Title";
import Loader from "./Loader";
import { useCongress } from "../../congress/hooks";
import VideoModal from "./VideoModal";
import ImageModal from "./ImageModal";

export default function Layout({ children, header }) {
  const { congress } = useCongress();

  const [videoModalOpen, setVideoModalOpen] = useState(true);
  const [imageModalOpen, setImageModalOpen] = useState(true);

  const [videoFilePath, setVideoFilePath] = useState(null);
  const imageFilePath = congress.LandingModalURL;

  useEffect(() => {
    if (congress.Name === "Congreso Veterinario Puyehue 2023") {
      setVideoFilePath("/landing/videos/puyehue.MP4");
    }
    if (congress.Name === "Congreso Veterinario Cartagena 2023") {
      setVideoFilePath("/landing/videos/cartagena.mp4");
    }
    if (congress.Name === "Panamá Business Veterinary 2023") {
      setVideoFilePath("/landing/videos/panama.MP4");
    }
    if (congress.Name === "Congreso Veterinario de Chile 2023 ") {
      setVideoFilePath("/landing/videos/congreso_chile.mp4");
    }
  }, [congress]);
  
  return (
    <LayoutContainer>
      <Head title={congress.Name} />
      <Header />
      <Menu />
      <Body>{children}</Body>
      {videoFilePath ? (
        <VideoModal
          videoURL={videoFilePath}
          show={videoModalOpen}
          onClose={() => setVideoModalOpen(false)}
        />
      ) : null}
      {imageFilePath ? (
        <ImageModal
          imageURL={imageFilePath}
          show={imageModalOpen}
          onClose={() => setImageModalOpen(false)}
        />
      ) : null}
    </LayoutContainer>
  );
}

const LayoutContainer = styled.div``;

const Body = styled.div`
  margin-top: 3rem;
  margin-bottom: 5rem;
`;

Layout.Container = Container;
Layout.Head = Head;
Layout.Title = Title;
Layout.Loader = Loader;
